import { Button } from "antd-mobile";
export default function ErrorPage(props: any) {
  const errorMessage = props.errorMessage;
  const refreshPage = props.refreshPage;
  return (
    <div className="bg-[#f7f7f7] w-100vw h-100vh fixed top-50% left-50% translate-[-50%] center flex-col gap-y-20 z-999">
      <div className="text-16 flex items-center font-weight-lighter gap-6 color-[#333]">{errorMessage}</div>
      <Button color="primary" fill="solid" size="small" onClick={() => refreshPage && refreshPage()}>
        Refresh
      </Button>
    </div>
  );
}
